import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-align-right",
  templateUrl: "./med-icon-align-right.component.html",
})
export class MedIconAlignRightComponent extends SvgMixinComponent {}
